import { render, staticRenderFns } from "./membershipfeesport.vue?vue&type=template&id=225defbe"
import script from "./membershipfeesport.vue?vue&type=script&lang=js"
export * from "./membershipfeesport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports